/* Copyright (c) 2017 Backpack Health LLC */

import ProfileModel from '../../../models/ProfileModel';
import UserModel from '../../../models/UserModel';
import FileModel from '../../../models/FileModel';

import { userSelectors } from '../../redux/selectors_authorizedApp';
import { selectors as listSelectors } from '../../redux/ducks/lists/lists';

export function getChangePasswordFlowData(state) {
  return state.userFlows.changePasswordFlow;
}

export function getFileUploadFlowData(state) {
  return state.userFlows.fileUploadFlow;
}

export function getEnableMfaFlowData(state) {
  return state.userFlows.enableMfaFlow;
}

export function getLoggedInUser(state) {
  return new UserModel(state.user);
}

export function getMainProfileId(state) {
  return state.user.profile_id;
}

export function getProfile(profileId, state) {
  const profiles = state.data.profiles.collection.filter((p) => p.id === profileId);
  return profiles.length > 0 ? new ProfileModel(profiles[0]) : new ProfileModel();
}

export function getActiveProfile(state) {
  const profileId = state.activeProfileId;
  const profiles = state.data.profiles.collection.filter((p) => p.id === profileId);
  const profile = profiles.length > 0 ? new ProfileModel(profiles[0]) : new ProfileModel();
  const colorTheme = listSelectors.getColorTheme(profile.getColorThemeId(), state);
  profile.setProfileColor(colorTheme.base_color);
  return profile;
}

export function getActiveProfileId(state) {
  return state.activeProfileId;
}

// ===========================
// REMOVE THESE

export function getProfiles(state) {
  return state.data.profiles.collection.map((p) => {
    const profile = new ProfileModel(p);
    const colorTheme = listSelectors.getColorTheme(profile.getColorThemeId(), state);
    profile.setProfileColor(colorTheme.base_color);
    return profile;
  });
}

export function getPendingChanges(state) {
  return state.pendingEdit;
}

export function getFilesForProfile(profileId, state) {
  return state.data.files[profileId] || { collection: [], lookup: {}, isFetching: false };
}

export function getFile(profileId, fileId, state) {
  const files = getFilesForProfile(profileId, state).collection.filter((f) => f.id === fileId);
  return files.length === 0 ? new FileModel() : new FileModel(files[0]);
}

// ===========================

export function getCurrentPassword(state) {
  return state.userFlows.changePasswordFlow.currentPassword;
}

export function getCurrentLocaleLanguageCode(state) {
  const localeId = userSelectors.getLocaleId(state);
  const localeData = listSelectors.getLocale(localeId, state);
  return localeData.language_code;
}

export function getIsMainProfile(state) {
  return getActiveProfileId(state) === getMainProfileId(state);
}

export function getIsActiveProfileResidenceUSA(state) {
  const profile = getActiveProfile(state);
  const country = listSelectors.getResidenceCountry(state, profile.residenceCountryId);
  return country.code === 'USA';
}

export function getActiveProfileDefaultCountryISO2(state) {
  const profile = getActiveProfile(state);
  const residentCountry = listSelectors.getResidenceCountry(state, profile.residenceCountryId);
  const iso2 = residentCountry.iso2;
  const defaultCountry = listSelectors.getCountryCollection(state).find(a => a.iso2 === iso2);
  return defaultCountry ? defaultCountry.iso2 : 'US';
}
